
<template>
  <div class="builder-music">
    <v-row>
      <v-col cols="12">
        <v-card outlined>
          <v-card-title>Settings</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-text-field label="Playlist Name" v-model="campaignName" />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  label="Track normal limit"
                  v-model.number="campaignTrackNormalLimit"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  label="Community playlist track limit"
                  hint="Leave empty to include all tracks"
                  persistent-hint
                  v-model.number="campaignCommunityPlaylistTrackLimit"
                  type="number"
                  min="1"
                  clearable
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  label="Track normal min"
                  v-model.number="campaignTrackNormalMin"
                />
              </v-col>
              <v-col cols="12">
                <v-select
                  label="Album types"
                  multiple
                  chips
                  v-model="campaignAlbumTypes"
                  :items="albumTypes"
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-switch
                  v-model="campaignIsFirstArtistOnly"
                  label="First artist only"
                ></v-switch>
              </v-col>
              <v-col cols="12">
                <v-select
                  label="Instrumental"
                  v-model="campaignInstrumental"
                  :items="instrumentalItems"
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-switch
                  data-testid="editor-setlist-switch"
                  v-model="isSetlist"
                  label="Setlist"
                  @change="onSetlist"
                  :disabled="!!campaignConnectedArtistPlaylist"
                ></v-switch>
                <span v-if="!!campaignConnectedArtistPlaylist"
                  >If artist playlist is set, setlist is not possible</span
                >
              </v-col>
              <v-col cols="12">
                <v-text-field
                  label="User playlist image URL"
                  v-model="campaignSetlistImageUrl"
                  @click="onUpload('cover')"
                  clearable
                />
                <v-text-field
                  label="Community playlist image URL"
                  v-model="campaignCommunitySetlistImageUrl"
                  @click="onUpload('communityCover')"
                  clearable
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12">
        <BuilderArtistLogin />
      </v-col>
      <v-col cols="12">
        <v-card outlined>
          <v-card-title>Artists</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <strong>Add artists</strong>
                <BuilderArtistSearch @add="addArtist" />
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                v-for="(_, index) in campaignArtistIds"
                :key="index"
                cy-id="artist-tile"
              >
                <BuilderArtistTile v-model="campaignArtistIds[index]">
                  <v-btn
                    color="warning"
                    dark
                    slot="button"
                    cy-id="artist-remove"
                    @click="removeArtist(index)"
                  >
                    Remove
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </BuilderArtistTile>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-card outlined>
          <v-card-title>Playlists</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <strong>Add playlist</strong>
                <BuilderPlaylistSearch @add="addPlaylist" />
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                v-for="(_, index) in campaignPlaylistIds"
                :key="index"
                cy-id="playlist-tile"
              >
                <BuilderPlaylistTile v-model="campaignPlaylistIds[index]">
                  <v-btn
                    color="warning"
                    dark
                    slot="button"
                    cy-id="playlist-remove"
                    @click="removePlaylist(index)"
                  >
                    Remove
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </BuilderPlaylistTile>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12">
        <BuilderMusicExternalTracks />
      </v-col>
      <v-col cols="12">
        <v-card outlined>
          <v-card-title>Tracks</v-card-title>
          <v-card-text>
            <BuilderMusicTracks />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-card outlined class="builder-follow-items">
          <v-card-title> Follow</v-card-title>
          <v-card-text>
            <v-row>
              <v-col sm="2">
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn color="green" v-on="on" dark>
                      <v-icon>mdi-plus</v-icon>
                      Add follow item
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="(type, index) in followTypeItems"
                      :key="index"
                      @click="addFollow(type)"
                    >
                      <v-list-item-title>{{ type }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
            </v-row>
            <v-row
              v-for="(followItem, index) in campaignFollowItems"
              :key="index"
            >
              <v-col>
                <v-card outlined>
                  <v-card-title>
                    <strong
                      >{{ followItem.service }} - {{ followItem.type }}</strong
                    >
                    <v-spacer></v-spacer>
                    <v-btn color="error" @click="removeFollow(index)"
                      >Remove</v-btn
                    >
                  </v-card-title>
                  <v-card-text v-if="followItem.type === 'playlist'">
                    <BuilderPlaylistTile
                      v-if="followItem.id"
                      v-model="followItem.id"
                    />
                    <BuilderPlaylistSearch
                      v-else
                      @add="campaignFollowItems[index].id = $event"
                    />
                  </v-card-text>
                  <v-card-text v-if="followItem.type === 'artist'">
                    <BuilderArtistTile
                      v-if="followItem.id"
                      v-model="followItem.id"
                    />
                    <BuilderArtistSearch
                      v-else
                      @add="campaignFollowItems[index].id = $event"
                    />
                  </v-card-text>
                  <v-card-text v-if="followItem.type === 'album'">
                    <BuilderAlbumTile
                      v-if="followItem.id"
                      v-model="followItem.id"
                    />
                    <BuilderAlbumSearch
                      v-else
                      @add="campaignFollowItems[index].id = $event"
                    />
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import BuilderPlaylistSearch from './BuilderPlaylistSearch.vue'
import BuilderArtistSearch from './BuilderArtistSearch.vue'
import BuilderPlaylistTile from './BuilderPlaylistTile.vue'
import BuilderArtistTile from './BuilderArtistTile.vue'
import BuilderMusicTracks from './BuilderMusicTracks.vue'
import BuilderAlbumSearch from './BuilderAlbumSearch.vue'
import BuilderAlbumTile from './BuilderAlbumTile.vue'
import BuilderArtistLogin from './BuilderArtistLogin.vue'
import BuilderMusicExternalTracks from './BuilderMusicExternalTracks.vue'
import { FilterAlbumType, FilterInstrumental, FollowItem, FollowItemType, SetlistTrackType } from '@/types'
import { Getter } from 'vuex-class'
import cms from '../../cms'

@Component({
  components: {
    BuilderPlaylistSearch,
    BuilderArtistSearch,
    BuilderPlaylistTile,
    BuilderArtistTile,
    BuilderMusicTracks,
    BuilderAlbumSearch,
    BuilderAlbumTile,
    BuilderArtistLogin,
    BuilderMusicExternalTracks
  }
})
export default class BuilderMusic extends Vue {
  @Getter campaignConnectedArtistPlaylist!: string

  albumTypes: FilterAlbumType[] = Object.values(FilterAlbumType)
  instrumentalItems: FilterInstrumental[] = Object.values(FilterInstrumental)
  followTypeItems: FollowItemType[] = Object.values(FollowItemType)

  isSetlist: boolean = this.campaignSetlistTrackTypes[0] !== SetlistTrackType.NORMAL

  created () {
    cms.onMediaPicked((data: { url: string, currentFileId: string }) => {
      switch (data.currentFileId) {
        case 'cover': {
          this.campaignSetlistImageUrl = data.url
          break
        }
        case 'communityCover': {
          this.campaignCommunitySetlistImageUrl = data.url
          break
        }
        default: {
          break
        }
      }
    })
  }

  onUpload (currentFileId: string) {
    console.log({ currentFileId })
    cms.openMediaLibrary(currentFileId)
  }

  get campaignName (): string {
    return this.$store.getters.campaignName
  }

  set campaignName (data: string) {
    this.$store.commit('SET_CAMPAIGN_PLAYLIST_NAME', data)
  }

  get campaignTrackNormalLimit (): number {
    return this.$store.getters.campaignTrackNormalLimit
  }

  set campaignTrackNormalLimit (data: number|null) {
    this.$store.commit('SET_CAMPAIGN_TRACK_NORMAL_LIMIT', data || null)
  }

  get campaignCommunityPlaylistTrackLimit (): number | null {
    return this.$store.getters.campaignCommunityPlaylistTrackLimit
  }

  set campaignCommunityPlaylistTrackLimit (data: number | null) {
    this.$store.commit('SET_CAMPAIGN_COMMUNITY_PLAYLIST_TRACK_LIMIT', data || null)
  }

  get campaignTrackNormalMin (): number {
    return this.$store.getters.campaignTrackNormalMin
  }

  set campaignTrackNormalMin (data: number) {
    this.$store.commit('SET_CAMPAIGN_TRACK_NORMAL_MIN', data)
  }

  get campaignAlbumTypes (): FilterAlbumType {
    return this.$store.getters.campaignAlbumTypes
  }

  set campaignAlbumTypes (data: FilterAlbumType) {
    this.$store.commit('SET_CAMPAIGN_ALBUM_TYPES', data)
  }

  get campaignIsFirstArtistOnly (): boolean {
    return this.$store.getters.campaignIsFirstArtistOnly
  }

  set campaignIsFirstArtistOnly (data: boolean) {
    this.$store.commit('SET_CAMPAIGN_IS_FIRST_ARTIST_ONLY', data)
  }

  get campaignInstrumental (): FilterInstrumental {
    return this.$store.getters.campaignInstrumental
  }

  set campaignInstrumental (data: FilterInstrumental) {
    this.$store.commit('SET_CAMPAIGN_INSTRUMENTAL', data)
  }

  get campaignSetlistTrackTypes (): SetlistTrackType[] {
    return this.$store.getters.campaignSetlistTrackTypes
  }

  set campaignSetlistTrackTypes (data: SetlistTrackType[]) {
    this.$store.commit('SET_CAMPAIGN_SETLIST_TRACK_TYPES', data)
  }

  get campaignSetlistImageUrl (): string {
    return this.$store.getters.campaignSetlistImageUrl
  }

  set campaignSetlistImageUrl (data: string) {
    this.$store.commit('SET_CAMPAIGN_SETLIST_IMAGE_URL', data)
  }

  get campaignCommunitySetlistImageUrl (): string {
    return this.$store.getters.campaignCommunitySetlistImageUrl
  }

  set campaignCommunitySetlistImageUrl (data: string) {
    this.$store.commit('SET_CAMPAIGN_COMMUNITY_SETLIST_IMAGE_URL', data)
  }

  get campaignPlaylistIds (): string[] {
    return this.$store.getters.campaignPlaylistIds
  }

  set campaignPlaylistIds (data: string[]) {
    this.$store.commit('SET_CAMPAIGN_PLAYLIST_IDS', data)
  }

  get campaignArtistIds (): string[] {
    return this.$store.getters.campaignArtistIds
  }

  set campaignArtistIds (data: string[]) {
    this.$store.commit('SET_CAMPAIGN_ARTIST_IDS', data)
  }

  get campaignFollowItems (): FollowItem[] {
    return this.$store.getters.campaignFollowItems
  }

  set campaignFollowItems (data: FollowItem[]) {
    this.$store.commit('SET_CAMPAIGN_FOLLOW_ITEMS', data)
  }

  onSetlist (value: boolean) {
    if (value === true) {
      this.campaignSetlistTrackTypes = [
        SetlistTrackType.OPENING,
        SetlistTrackType.NORMAL,
        SetlistTrackType.CLOSING,
        SetlistTrackType.ENCORE,
      ]
    } else {
      this.campaignSetlistTrackTypes = [
        SetlistTrackType.NORMAL,
      ]
    }
  }

  addPlaylist (id: string) {
    this.campaignPlaylistIds.push(id)
  }

  removePlaylist (index: number) {
    this.campaignPlaylistIds.splice(index, 1)
  }

  addArtist (id: string) {
    this.campaignArtistIds.push(id)
  }

  removeArtist (index: number) {
    this.campaignArtistIds.splice(index, 1)
  }

  addFollow (type: FollowItemType) {
    this.campaignFollowItems.push({
      type,
      id: '',
      service: 'spotify',
    })
  }

  removeFollow (index: number) {
    this.campaignFollowItems.splice(index, 1)
  }
}
</script>
